import styled from 'styled-components';

interface ContainerProps {
  position: 'fixed' | 'absolute' | 'relative';
}

export const Container = styled.div<ContainerProps>`
  background: #000;
  display: flex;
  height: 100vh;
  position: ${props => props.position};
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  flex-direction: column;
  align-items: center !important;
  justify-content: center  !important;
  z-index: 10000;

  >aside.loaderH3  {
    color: white;
    font-size: 16px;
    font-weight: bold;
    margin-top: 20px;
    width: 100%;
    text-align: center !important;
  }
  > img {
    width: 100%;
    max-width: 200px;
 
  }
`;
